/**
 * @generated SignedSource<<886096772b9196a47f7434cba6024a55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type UpdateValveConnectorInput = {
  valveConnectorId: string;
  updateValveConnectorData: UpdateValveConnectorData;
  clientMutationId?: string | null;
};
export type UpdateValveConnectorData = {
  name?: string | null;
};
export type updatePageUpdateValveConnectorMutation$variables = {
  input: UpdateValveConnectorInput;
};
export type updatePageUpdateValveConnectorMutationVariables = updatePageUpdateValveConnectorMutation$variables;
export type updatePageUpdateValveConnectorMutation$data = {
  readonly updateValveConnector: {
    readonly valveConnector: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type updatePageUpdateValveConnectorMutationResponse = updatePageUpdateValveConnectorMutation$data;
export type updatePageUpdateValveConnectorMutation = {
  variables: updatePageUpdateValveConnectorMutationVariables;
  response: updatePageUpdateValveConnectorMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateValveConnectorPayload",
    "kind": "LinkedField",
    "name": "updateValveConnector",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValveConnector",
        "kind": "LinkedField",
        "name": "valveConnector",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageUpdateValveConnectorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageUpdateValveConnectorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d512f91347a38360c818db2af763ec63",
    "id": null,
    "metadata": {},
    "name": "updatePageUpdateValveConnectorMutation",
    "operationKind": "mutation",
    "text": "mutation updatePageUpdateValveConnectorMutation(\n  $input: UpdateValveConnectorInput!\n) {\n  updateValveConnector(input: $input) {\n    valveConnector {\n      id\n      createdAt\n      name\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b008d64e1691eac76d3cdb4d384c99c1";

export default node;
